/**
 * useAffiliateSettingsSync — copies affiliate/UTM tracking data from
 * localStorage to db.setting (synced table) on login.
 *
 * v1 equivalent: Layout.tsx useEffect that reads `totodo_analytics_*` keys
 * and stores them as `db.setting.put({ id: "#affiliate", value: "CODE", ... })`.
 *
 * Why db.setting? The setting table is synced by Dexie Cloud, so the
 * attribution data persists across devices and is available server-side.
 * The localStorage entry is removed after successful write to avoid duplicates.
 *
 * Runs once on mount — safe to call on every app start (no-ops if no data).
 */

import { useEffect } from "react"
import { db } from "@/db/schema"

const TRACKING_PARAMS = [
  "affiliate",
  "utm_source",
  "utm_content",
  "utm_medium",
  "utm_term",
  "utm_campaign",
  "fbclid",
  "gclid",
] as const

export function useAffiliateSettingsSync(): void {
  useEffect(() => {
    async function syncTrackingToSettings() {
      for (const param of TRACKING_PARAMS) {
        const key = `totodo_analytics_${param}`
        const value = localStorage.getItem(key)
        if (value) {
          await db.setting.put({
            id: `#${param}`,
            value,
            device: "n/a",
            createdAt: new Date().toISOString(),
            createdBy: "link",
          })
          localStorage.removeItem(key)
        }
      }
    }

    syncTrackingToSettings().catch((err) => {
      console.warn("[AffiliateSync] Failed to sync tracking data:", err)
    })
  }, [])
}
